import {
  apiGetFeedItems,
  apiRejectWork,
  apiApproveWork,
  apiAddStudentsToSession
} from '../../common/api/pupil-activity'

export const fetchFeedItems = (data = {}) => ({
  params: data,
  requestPrefix: 'FEED_ITEMS:FETCH',
  request: () =>
    apiGetFeedItems({
      ...data,
      include:
        'pa_action_feed_item.pa_action.presentation.names,pa_action_feed_item.pa_action.presentation.image,pa_session.timestamps,pa_action_feed_item.pa_action.pa_work_versions,pa_action_feed_item.pa_action.last_pa_work_version.work.media,pa_action_feed_item.pa_action.last_pa_work_version.work.medium.image,pa_action_feed_item.pa_action.last_pa_work_version.work.medium.details,pa_action_feed_item.pa_action.student.names,pa_action_feed_item.pa_action.student.avatar,pa_action_feed_item.pa_action.student.student_type.policy,pa_action_feed_item.pa_action.pa_session.details,pa_action_feed_item.pa_action.last_pa_work_version.success_criteria,pa_action_feed_item.pa_action.last_pa_work_version.work.medium.pa_highlight_canva.data,pa_action_feed_item.pa_action.pa_reviews,pa_action_feed_item.pa_action.pa_review.type,pa_action_feed_item.pa_action.pa_review.pa_review_comments,pa_action_feed_item.pa_action.pa_review.pa_review_comment.content,pa_action_feed_item.pa_action.pa_review.pa_review_comment.author.names,pa_action_feed_item.pa_action.pa_review.pa_review_comment.author.avatar'
    })
})

export const rejectWork = ({ feedId, workVersionId, comment }) => ({
  params: { feedId, workVersionId },
  requestPrefix: 'FEED_ITEMS:REJECT_WORK',
  request: () => apiRejectWork(workVersionId, { comment })
})

export const approveWork = ({ feedId, workVersionId, data }) => ({
  params: { feedId, workVersionId, data },
  requestPrefix: 'FEED_ITEMS:APPROVE_WORK',
  request: () => apiApproveWork(workVersionId, data)
})

export const addStudentsToSession = (sessionId, studentIds) => ({
  requestPrefix: 'FEED_ITEMS:ADD_STUDENTS_TO_SESSION',
  request: () => apiAddStudentsToSession(sessionId, { account_ids: studentIds })
})
